export type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

/** Stable English `name` from sidebar config → localized label. */
export function menuLabel(t: TranslateFn, name: string): string {
  return t(`menu.${name}`, { defaultValue: name });
}

export function viewLabel(t: TranslateFn, label: string): string {
  return t(`views.${label}`, { defaultValue: label });
}

export function sidebarTabLabel(t: TranslateFn, tab: string): string {
  return t(`tabs.${tab}`, { defaultValue: tab });
}

export function sidebarWorkspaceLabel(t: TranslateFn, workspace: string): string {
  return t(`workspaces.${workspace}`, { defaultValue: workspace });
}

/** Map legacy hardcoded English UI strings from module configs to common namespace keys. */
export function resolveCommonAction(t: TranslateFn, value: string): string {
  switch (value) {
    case 'Cancel':
      return t('cancel');
    case 'Save':
      return t('save');
    case 'Create':
      return t('actions.create');
    case 'Update':
      return t('actions.update');
    case 'Edit':
      return t('actions.edit');
    case 'Done':
      return t('actions.done');
    case 'Back':
      return t('actions.back');
    case 'Back to List':
      return t('actions.backToList');
    case 'Loading...':
      return t('states.loading');
    default:
      return value;
  }
}
